module.exports = __webpack_public_path__ + "static/media/book10_innovatieve-ontwerpen.85c84241.png";